module.exports = __webpack_public_path__ + "img/frontend_base_contato.715abdd0.jpg";